import { isProd } from './environment';

export const isTariffComparatorDemo = !isProd && !!localStorage.getItem('tariffComparator');
export const isDemoPushNotifications = !isProd && !!localStorage.getItem('demoPushNotifications');
export const isEcoPointsDemo = !isProd && !!localStorage.getItem('ecoPoints');
export const isEkoOzeDashboardDemo = !isProd && !!localStorage.getItem('ekoOzeDashboardDemo');
export const isWeatherDashboardDemo = !isProd && !!localStorage.getItem('weatherDashboardDemo');
